// Include plugin: https://github.com/maxwellito/vivus
// Reference: https://maxwellito.github.io/vivus/
var Vivus = require('../../../node_modules/vivus/dist/vivus.js');

$(document).ready(function() {

	$('.power__animation').each(function() {
		var $this = $(this);
		var doAnimation = new Vivus(
			$this[0],
			{
				file: '/_resources/app/client/assets/animations/animation-image.svg',
				type: 'scenario-sync',
				duration: 30,
				start: 'manual'
			},
			function() { LightingUp_Lightbulb($this); }
		);

		$(window).on('scroll', function() {
			if ($this.isInViewport()) {
				if(doAnimation.getStatus() == 'start'){
					doAnimation.play();
				}
			}
		});
	});

	function LightingUp_Lightbulb($container) {
		$container.find('#window_0').delay(100).queue(function() { setLightbulbStyle($(this)); });
		$container.find('#window_1').delay(150).queue(function() { setLightbulbStyle($(this)); });
		$container.find('#window_2').delay(200).queue(function() { setLightbulbStyle($(this)); });
		$container.find('#window_3').delay(250).queue(function() { setLightbulbStyle($(this)); });
		$container.find('#window_4').delay(300).queue(function() { setLightbulbStyle($(this)); });
		$container.find('#window_5').delay(350).queue(function() { setLightbulbStyle($(this)); });
		$container.find('.st0').delay(400).queue(function() {
			$(this).css({
				fill: '#FDB930'
			});
		});
		$('.background__graphic .background__polygon').delay(3910).queue(function() {
			$(this).css({
				backgroundColor: '#FDB930'
			});
		});
		$container.find('.st4, .st5').delay(400).queue(function() {
			$(this).css({
				fill: '#FDB930',
				stroke: '#000000'
			});
		});
	}

	function setLightbulbStyle($element) {
		$element.css({
			fill: '#FDB930',
			stroke: 'transparent'
		});
	}
});

// Custom jQuery function to check if the element is in viewport
$.fn.isInViewport = function() {
	var elementTop = $(this).offset().top;
	var elementBottom = elementTop + $(this).outerHeight();
	var viewportTop = $(window).scrollTop();
	var viewportBottom = viewportTop + $(window).height();
	return elementBottom > viewportTop && elementTop < viewportBottom;
};